var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicVrEarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 52,
    viewBox: "0 0 45 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(2 2)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.53,
    stroke: "#E10A0A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.765 41.403H6.859v-6.58h28.906zM4.706 41.403h28.905V48H4.706z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.02 20.235 20.235)",
    cx: 20.235,
    cy: 20.235,
    rx: 14.256,
    ry: 14.361
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.233 11.453c4.88 0 8.848 3.933 8.848 8.778"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicVrEarn);
export default __webpack_public_path__ + "static/media/graphic-vr-earn.f31f380ba929106e7750071627699095.svg";
export { ForwardRef as ReactComponent };